








import Vue, { PropType } from "vue";
import log from "loglevel";

import { PostContractResponse } from "@/containers/sale/api";

const ERROR_MESSAGE_TYPE_REDIRECT = "redirect";

export interface SaleContractRegisterProps {
  returnUrl: string;
  errorUrl: string;
  transactionId: string;
  saveContract: any;
  waitingTime: number;
}

export interface SaleContractRegisterData {
  isComplete: boolean;
}

export default Vue.extend({
  name: "vc-sale-contract-register",
  props: {
    returnUrl: {
      type: String as PropType<SaleContractRegisterProps["returnUrl"]>,
      default: ""
    },
    errorUrl: {
      type: String as PropType<SaleContractRegisterProps["errorUrl"]>,
      default: ""
    },
    transactionId: {
      type: String as PropType<SaleContractRegisterProps["transactionId"]>,
      default: ""
    },
    waitingTime: {
      type: Number as PropType<SaleContractRegisterProps["waitingTime"]>,
      default: 0
    },

    // actionsToProps
    postContract: {
      type: Function as PropType<SaleContractRegisterProps["saveContract"]>,
      default: () => {}
    }
  },
  data(): SaleContractRegisterData {
    return {
      isComplete: false
    };
  },
  mounted() {
    this.executionPostContract();
  },
  methods: {
    async executionPostContract() {
      const requestData = {
        transactionId: this.transactionId
      };
      try {
        const res: PostContractResponse = await this.postContract(requestData);
        this.isComplete = true;
        if (!(res && res.status === "success")) {
          window.location.href = this.errorUrl + "?type=default_error";
        }

        window.location.href =
          this.returnUrl + "?contractNumber=" + res.contractNumber;
      } catch (error) {
        log.error(error);
        this.isComplete = true;

        if (!error) {
          window.location.href = this.errorUrl + "?type=default_error";
          return;
        }

        // セール期間外だとリダイレクトURLが送られてくる
        if (
          error.messageType === ERROR_MESSAGE_TYPE_REDIRECT &&
          error.returnUrl
        ) {
          window.location.href = error.returnUrl;
          return;
        }

        window.location.href =
          this.errorUrl +
          "?type=" +
          error.messageType +
          "&errorCode=" +
          error.errorCode;

        throw error;
      }
    }
  }
});
